import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LocationList from "../Components/Location";
import API from '../Services/PartyProduct'
import ActivityTypeList from "../Components/ActivityTypeList";
import ActivityType from "../Components/ActivityType";
import ProductActivityList from "../Components/ProductActivityList";
import CenterModal from "../Components/CenterModal"
import TaxRateListList from '../Components/TaxRate'
import ProductModal from "../Components/ProductModal";
import AddOnList from "../Components/AddOnList";

const PartyProduct = () => {
    const [locationId, setLocationId] = useState("");
    const [activityTypeName, setActivityTypeName] = useState("");
    const [activityTypeDisplayName, setActivityTypeDisplayName] = useState("");
    const [activityName, setActivityName] = useState("");
    const [playPoint, setPlayPoint] = useState("");
    const [amount, setAmount] = useState("");
     const [specialAmount, setSpecialAmount] = useState("");
    
    const [image, setImage] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [activeSection, setActiveSection] = useState("productType");
    const [timeValue, setTimeValue] = useState("");
    const [timeValue1, setTimeValue1] = useState("");
    const [error, setError] = useState({});
    const [activityTypeId, setActivityTypeId] = useState("");

    const [selectedCenter, setSelectedCenter] = useState([]);
    const [selectedActivityCenter, setSelectedActivityCenter] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState([]);
    // const [singleTax, setSingleTax] = useState("")
    const [comboTax, setComboTax] = useState("")
    const [productId, setProductId] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);

    const [showActivityList, setShowActivityList] = useState(false);

    const staticHours = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    const staticMinutes = ["0", "15", "30", "45"];
    const [addOnId, setAddOnId] = useState("");
    const [isAddOn, setIsAddOn] = useState(false);
    const [allDaysChecked, setAllDaysChecked] = useState(false);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "activityTypeName":
                setActivityTypeName(value);
                break;
            case "activityName":
                setActivityName(value);
                break;
            case "amount":
                setAmount(value);
                break;
            case "timeValue":
                setTimeValue(value);
                break;
            case "timeValue1":
                setTimeValue1(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
                case "specialAmount":
                setSpecialAmount(value);
                break;
            default:
                break;
                
        }
        if (fieldName === "playPoint") {
            setPlayPoint(value);
            if (value.trim() !== "") {
                setError((prev) => ({ ...prev, playPoint: "", time: "" }));
            } else if (!timeValue1?.trim()) {
                setError((prev) => ({ ...prev, playPoint: "Enter SkyCoins or Minutes", time: "Minutes are required if SkyCoins is blank" }));
            }
        }

        if (fieldName === "timeValue1" || fieldName === "timeValue") {
            if (fieldName === "timeValue") setTimeValue(value);
            else setTimeValue1(value);

            if (!playPoint?.trim()) {
                if (!value.trim()) {
                    setError((prev) => ({
                        ...prev,
                        time: "Minutes are required if SkyCoins is blank",
                        playPoint: "Enter SkyCoins or Minutes"
                    }));
                } else if (fieldName === "timeValue1" && value.trim()) {
                    setError((prev) => {
                        const updatedErrors = { ...prev };
                        delete updatedErrors.time;
                        delete updatedErrors.playPoint;
                        return updatedErrors;
                    });
                }
            }
        }

        if (fieldName === "amount") {
            setAmount(value);
            if (value.trim() !== "") {
                setError((prev) => ({ ...prev, amount: "" }));
            }
        }
    };

    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedFormats = ["image/png"];
            const maxSize = 5 * 1024 * 1024;

            if (!allowedFormats.includes(file.type)) {
                toast.error("Only PNG formats are allowed.");
                return;
            }

            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.");
                return;
            }

            setImage(file);
            setLogoPreview(URL.createObjectURL(file));
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.image;
                return updatedErrors;
            });
        }
    };

    const validateFields = () => {
        const errors = {};
        const priceRegex = /^\d+(\.\d{1,2})?$/;

        if (activeSection === "productType") {
            if (!activityTypeName.trim()) errors.activityTypeName = "Name is required";
            // if (!activityTypeDisplayName.trim()) errors.activityTypeDisplayName = "Display Name is required";
            if (!image) errors.image = "Image is required";
        }

        if (activeSection === "product") {
            if (!activityName.trim()) errors.activityName = "Activity Name is required";

            const isPlayPointValid = playPoint && priceRegex.test(playPoint);
            const isTimeProvided = !!timeValue1;

            if ((isPlayPointValid && isTimeProvided) || (!isPlayPointValid && !isTimeProvided)) {
                errors.playPoint = "Choose either SkyCoins or Time (not both)";
                errors.time = "Choose either Time or SkyCoins (not both)";
            }
            if (playPoint && !priceRegex.test(playPoint)) {
                errors.playPoint = "Valid SkyCoins is required";
            }
            if (!amount || !priceRegex.test(amount)) {
                errors.amount = "Valid Mrp is required";
            }
            // if (!isAddOn) {
            //     errors.isAddOn = "isAddOn is required";
            // }

        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const addActivity = async () => {

        if (!comboTax || comboTax.length === 0 || comboTax == 'Select') {
            toast.error("Tax Rate is required");
            return;
        }
        if (isAddOn === true) {
            if (!addOnId || addOnId.length === 0 || addOnId == 'Select') {
                toast.error("Add On is required");
                return;
            }
        }

        const timeValueHourse = parseFloat(timeValue) * 60;
        const time = parseFloat(timeValueHourse) + parseFloat(timeValue1);
        const isMultiple = activityTypeId.length === 1 ? 0 : 1;

        let addOnRequred = isAddOn !== "" ? isAddOn : false;

        const payload = {
            activity_type_id: activityTypeId,
            name: activityName,
            display_order: 1,
            playpoint: parseInt(playPoint) || 0,
            //play_point: parseInt(playPoint),
            time: parseFloat(timeValue1) || 0,
            amount: parseFloat(amount) || 0,
            is_multiple: isMultiple,
            tax_rate_id: comboTax || 0,
            map_product_id: productId || 0,
            is_addons: addOnRequred,
            map_addons: [addOnId.toString()],
            special_price:specialAmount || 0
        };
        // console.log('payload', payload);
        try {
            const response = await API.addActivity(payload);
            if (response.status == 201 || response?.status === 200) {
                toast.success(response?.data?.message || "Add-on Activity Type successfully!");
                setActiveSection('product');
                setRefreshKey(prev => prev + 1);
                setShowActivityList(true);
                handleCancel()
            }
        } catch (error) {
            console.error('Error adding activity:', error);

            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            } else {

                console.warn('Something went wrong. Please try again.');
            }
        }
    };

    const handleSubmit = () => {
        if (!validateFields()) return;
        addActivityTypeData()
    };
    const handleSubmitActivity = () => {
        if (!validateFields()) return;
        addActivity()
    };

    const addActivityTypeData = async () => {
        const selectedDays = Object.keys(weekdays).filter(day => weekdays[day]);
        if (!Array.isArray(selectedDays) || selectedDays.length === 0) {
            toast.error("Please select at least one weekday.");
            return;
        }

        const weekList =
            selectedDays.length === allWeekdays.length
                ? "All Days"
                : selectedDays.join(", ");

        const location_id = Array.isArray(selectedCenter) ? selectedCenter.join(", ") : selectedCenter;
        const isMultiple = location_id.length === 1 ? 0 : 1;
        const formData = new FormData();
        formData.append("location_id", location_id);
        formData.append("name", activityTypeName);
        formData.append("is_multiple", isMultiple);
        formData.append("week_list", weekList);

        if (image instanceof File) {
            formData.append("icon", image);
        }
        try {
            const response = await API.addActivityProduct(formData);
            if (response?.status === 200 || response?.status === 201) {
                toast.success(response?.data?.message || "Add-on Activity Type successfully!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to activity type.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }
    };

    const handleCancel = () => {

        setActivityTypeId("");
        setActivityName("");
        setPlayPoint("");
        setTimeValue1("");
        setAmount("")
    };

    const buttonStyle = (type) => ({
        padding: "10px 20px",
        marginRight: "10px",
        cursor: "pointer",
        backgroundColor: activeSection === type ? "#2c03fc" : "#555555",
        color: "#ffffff",
        border: "none",
        borderRadius: "4px",
        fontWeight: "bold",
        transition: "background-color 0.3s ease, color 0.3s ease",
    });
    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };
    const handleSelectedActivityCenter = (selectedData) => {
        setSelectedActivityCenter(selectedData);
    };
    const handleSelectedProduct = (selectedData) => {
        setSelectedProduct(selectedData);
    };
    const allWeekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    const handleAllDaysToggle = () => {
        const newState = !allDaysChecked;
        const updatedWeekdays = {};
        allWeekdays.forEach(day => {
            updatedWeekdays[day] = newState;
        });
        setWeekdays(updatedWeekdays);
        setAllDaysChecked(newState);
    };
    const handleWeekdayChange1 = (day) => {
        const updated = {
            ...weekdays,
            [day]: !weekdays[day],
        };
        setWeekdays(updated);

        // Update "All Days" checkbox status
        const allSelected = allWeekdays.every(d => updated[d]);
        setAllDaysChecked(allSelected);
    };
    const [weekdays, setWeekdays] = useState({
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
    });

    return (
        <div>
            <button style={buttonStyle("productType")} onClick={() => setActiveSection("productType")}>Activity Type</button>
            <button style={buttonStyle("product")} onClick={() => setActiveSection("product")}>Activity</button>

            {activeSection === "productType" && (
                <div className="col-12 grid-margin stretch-card mt-3">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Activity Type</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-6">
                                        <CenterModal onSelectCenter={handleSelectedCenter} />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Name <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Name"
                                            value={activityTypeName}
                                            onChange={(e) => handleFieldChange(e, "activityTypeName")}
                                        />
                                        {error.activityTypeName && <small className="text-danger" style={{ fontSize: "12px" }}>{error.activityTypeName}</small>}
                                    </div>

                                </div>
                                <div className="row mt-1">
                                    <div className="col-md-12">
                                        <label>Weekday List (All Days)
                                            <input
                                                type="checkbox"
                                                checked={allDaysChecked}
                                                onChange={handleAllDaysToggle}
                                                className="form-check-input ms-3"
                                                style={{ border: '2px solid black' }}
                                            /></label>
                                        <div className="d-flex flex-wrap">
                                            {allWeekdays.map((day) => (
                                                <div className="form-check me-3" key={day}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input ms-1"
                                                        id={day}
                                                        checked={weekdays[day] || false}
                                                        onChange={() => handleWeekdayChange1(day)}
                                                        style={{ border: '2px solid black' }}
                                                    />
                                                    <label htmlFor={day} className="form-check-label">{day}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Upload Icon <span className="text-danger">*</span></label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/png"
                                            onChange={handleLogoChange}
                                        />
                                        {error.image && <span className="text-danger" style={{ fontSize: "12px" }}>{error.image}</span>}
                                    </div>

                                    <div className="col-md-4">
                                        {logoPreview && (
                                            <img
                                                src={logoPreview || 'No Image Available'}
                                                alt="Preview"
                                                style={{ width: 100, height: 100, objectFit: "cover", marginTop: 10 }}
                                            />
                                        )}
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <button className="btn btn-primary me-2" onClick={handleSubmit}>Submit</button>
                                    <button className="btn btn-light" onClick={handleCancel}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {activeSection === "product" && (
                <div className="col-12 grid-margin stretch-card mt-3">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Activity</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-3">

                                        <CenterModal onSelectCenter={handleSelectedActivityCenter} />
                                    </div>
                                    <div className="col-md-3">
                                        <ActivityType
                                            selectedActivityType={activityTypeId}
                                            setSelectedActivityType={setActivityTypeId}
                                            selectedActivityCenter={selectedActivityCenter}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <ProductModal onSelectProduct={setProductId} selectedActivityCenter={selectedActivityCenter} />
                                    </div>

                                    <div className="col-md-3">
                                        <label>Activity Name <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Activity Name"
                                            value={activityName}
                                            onChange={(e) => handleFieldChange(e, "activityName")}
                                        />
                                        {error.activityName && <small className="text-danger" style={{ fontSize: "12px" }}>{error.activityName}</small>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <TaxRateListList selectedTaxRate={comboTax} setSelectedTaxRate={setComboTax}
                                            taxRates={comboTax}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Duration In Minute <span className="text-danger" style={{ fontSize: "12px" }}>*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Duration In Minute"
                                            value={timeValue1}
                                            onChange={(e) => handleFieldChange(e, "timeValue1")}
                                        />
                                    </div>
                                       <div className="col-md-3">
                                        <label>MRP (Normal) <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="Mrp"
                                            value={amount}
                                            onChange={(e) => handleFieldChange(e, "amount")}
                                        />
                                        {error.amount && <small className="text-danger" style={{ fontSize: "12px" }}>{error.amount}</small>}
                                    </div>
                                    <div className="col-md-3">
                                        <label>MRP (SPCL) 
                                            {/* <span className="text-danger">*</span> */}
                                            </label>
                                        <input
                                            className="form-control"
                                            placeholder="Special MRP"
                                            value={specialAmount}
                                            onChange={(e) => handleFieldChange(e, "specialAmount")}
                                        />
                                        {error.specialAmount && <small className="text-danger" style={{ fontSize: "12px" }}>{error.specialAmount}</small>}
                                    </div>

                                    {/* <div className="col-md-4">
                                        <label>SkyCoins <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            placeholder="SkyCoins"
                                            value={playPoint}
                                            onChange={(e) => handleFieldChange(e, "playPoint")}
                                        />
                                        {error.playPoint && <small className="text-danger" style={{ fontSize: "12px" }}>{error.playPoint}</small>}
                                    </div> */}


                                </div>
                                <div className="row">

                                 
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="IsAddOn" className="form-label">
                                                IsAddOn <span className="text-danger">*</span>
                                            </label>
                                            <div className="form-check">

                                                <input
                                                    type="checkbox"
                                                    className="form-check-input ms-1"
                                                    id="IsAddOn"
                                                    checked={isAddOn}
                                                    onChange={(e) => setIsAddOn(e.target.checked)}
                                                    style={{ border: '2px solid black' }}
                                                />
                                            </div>
                                            {error.isAddOn && <small className="text-danger" style={{ fontSize: "12px" }}>{error.isAddOn}</small>}
                                        </div>
                                    </div>

                                    {isAddOn && (
                                        <div className="col-md-4">
                            
                                            <AddOnList
                                                selectedAddOn={addOnId}
                                                setSelectedAddOn={setAddOnId}
                                                selectedActivityCenter={selectedActivityCenter}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="mt-1">
                                    <button className="btn btn-primary me-2" onClick={handleSubmitActivity}>Submit</button>
                                    <button className="btn btn-light" onClick={handleCancel}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
            {activeSection === "productType" && (
                < ActivityTypeList />
            )}
            {activeSection === "product" && (
                <ProductActivityList key={refreshKey} />
            )}
        </div>
    );
};

export default PartyProduct;

